import React from "react";
import {
  AbsoluteSphere,
  BottomText,
  CenterText,
  EthnosContainer,
  MiddleText,
  Mission,
  PixelSideText,
  Plus,
  TrTag,
  ZIndex,
} from "./styles";
import Sphere from "../../content/assets/Sphere.png";
import { textData as data } from "../../content/data/OurEthnosData";

const OurEthnos = () => {
  return (
    <EthnosContainer>
      <AbsoluteSphere>
        <img src={Sphere} alt="sphere"/>
      </AbsoluteSphere>
      <ZIndex direction="column" align="center">
        <CenterText justify="center">
          <TrTag>
            <Plus>+</Plus>
            {data.trand}
          </TrTag>
        </CenterText>
        <Mission gap="10vw">
          <PixelSideText>{data.our}</PixelSideText>
          <MiddleText>{data.missionText}</MiddleText>
          <PixelSideText>{data.mission}</PixelSideText>
        </Mission>
        <BottomText justify="space-between">
          <TrTag>
            <Plus>+</Plus>
            {data.work}
          </TrTag>
          <TrTag>
            <Plus>+</Plus>
            {data.reliable}
          </TrTag>
        </BottomText>
      </ZIndex>
    </EthnosContainer>
  );
};

export default OurEthnos;
